module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admins/user-add/user-add.component.css
// module id = ./src/app/admins/user-add/user-add.component.css
// module chunks = main